import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Tooltip from "components/Tooltip";

import { useOnboardingStepsData } from "scenes/Onboarding/components/OnboardingStepsProvider";

export function RateSelector({ planOptions, onSelected, selected }) {
  const { store } = useOnboardingStepsData();

  return (
    <Button.Group style={{ margin: "20px 0 10px 0" }}>
      {planOptions.map((p, i) => {
        return (
          <Tooltip
            key={`${p.planId}-option`}
            title="Remove coupon to change plan"
            position="top center"
            hidden={
              !store?.subscription?.coupons || selected?.planId === p.planId
            }
          >
            <div>
              <Button
                primary={selected?.planId === p.planId}
                disabled={
                  store.subscription?.coupons && selected?.planId !== p.planId
                }
                style={
                  i === 0
                    ? { borderTopRightRadius: 0, borderBottomRightRadius: 0 }
                    : { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (selected?.planId !== p.planId) {
                    onSelected(p);
                  }
                }}
              >
                {p.name}
              </Button>
            </div>
          </Tooltip>
        );
      })}
    </Button.Group>
  );
}

const PlanOptionShape = PropTypes.shape({
  planId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

RateSelector.propTypes = {
  onSelected: PropTypes.func.isRequired,
  selected: PlanOptionShape,
  planOptions: PropTypes.arrayOf(PlanOptionShape),
};

RateSelector.defaultProps = { planOptions: [], selected: undefined };

export default RateSelector;
